import { createSlice } from "@reduxjs/toolkit";

export const recommendedIntegrationsSlice = createSlice({
    name: "recommandedIntegrations",
    initialState: {
        recommended: {}
    },
    reducers: {
        changeRecommendations: (state, {payload}) => {
            state.recommended = payload
        }
    }
})

export const { changeRecommendations } = recommendedIntegrationsSlice.actions;

export default recommendedIntegrationsSlice.reducer;